// extracted by mini-css-extract-plugin
export default {"container":"ArchiveAlert_container__1hW8i","btn":"ArchiveAlert_btn__zOZ8M"};